import { useEffect } from "react";
import { diagnosticChecklistStore as store } from "./diagnosticChecklistStore.ts";
import { DiagnosticChecklist } from "./diagnosticChecklistTypes.ts";

export default function useRegisterDiagnosticChecklist(
  checklist: DiagnosticChecklist
) {
  const { id } = checklist;

  // Unregister only when the component unmounts or when the id changes.
  // Do not unregister on each content update. Map.delete and then Map.set
  // move the entry to the end of the order. The dialog sections then change
  // position when only the data changes.
  useEffect(() => {
    return () => store.unregister(id);
  }, [id]);

  // Keep the content current. The entry for this id exists after the first
  // run. Thus Map.set changes the value in place and keeps the order.
  useEffect(() => {
    store.register(checklist);
  }, [checklist]);
}
